import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findTabulateDetailList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/tabulateDetail?` + params,
        method: 'GET'
    })
}
export const findTabulateDetailListDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/tabulateDetailExcel?` + params,
        method: 'GET'
    })
}